import { Injectable } from "@angular/core";
import { LocalConfigService } from "./local-config.service";
import { user, userSession, workplaces } from '../../constants/names-local.constants';
import { ModuleHolidayDaysDto } from 'src/app/core/models/configuration/holidayDays/module-holiday-day.dto';
import { LockTypesDto } from "../../models/configuration/holidayDays/lock-type.dto";
import { FormOrgLangDto } from "../../models/configuration/forms/form-org-lan.dto";
import { VitalSignResponse } from "../../models/configuration/vitalSigns/vital-sign.response";
import { UnitMenu } from "../../models/module/unit-menu.dto";
import { ProcedureDto } from "../../models/configuration/procedures/procedure.dto";
import { ProcedureTypeDto } from "../../models/configuration/procedures/catalog-procedure-type.dto";
import { ProcedureUpdateDto } from "../../models/configuration/procedures/catalog-procedure-update.dto";
import { SexTypeDto } from "../../models/configuration/procedures/catalog-sex-type.dto";
import { UnitiesMeasurementDto } from "../../models/configuration/vitalSigns/unities-measurement.dto";
import { VitalSignTypeDto } from "../../models/configuration/vitalSigns/vital-sign-type.dto";
import { OptionSexDto } from "../../models/configuration/vitalSigns/option-sex.dto";
import { ClueAgeDto } from "../../models/configuration/vitalSigns/clue-age.dto";
import { StringUtilsHelper } from "../../shared/helpers/strings.helper";


@Injectable({
    providedIn: 'root'
})
export class WorkplaceStorageService {
    static localConfigServiceStatic: LocalConfigService;
    constructor(private localConfigService: LocalConfigService) {
        WorkplaceStorageService.localConfigServiceStatic = localConfigService;
    }

    saveUserSession(orgId : number, branchId : number, profileId : number){
        this.localConfigService.saveElement(userSession.idorg, orgId);
        this.localConfigService.saveElement(userSession.idbranch, branchId);
        this.localConfigService.saveElement(userSession.idprofile, profileId);
    }

    saveWorkplaces(workplace : any){
        this.localConfigService.saveElement(workplaces, JSON.stringify(workplace));
    }

    saveLanguageCve(languageCve : string){
        this.localConfigService.saveElement(userSession.languageCve, languageCve);
    }

    static saveObjTraduction(obj : string){
        this.localConfigServiceStatic.saveElement(userSession.formsByLanCveAndOrgId, obj);
    }

    static savePatientData(data: any){
        this.localConfigServiceStatic.saveElementJson("patient-data", data);
    }

    static getPatientData(){
        try {
            return this.localConfigServiceStatic.getElementJson("patient-data");
        } catch (error) {
            return "";
        }
    }

    static saveFormPatientInformation(data: any){
        this.localConfigServiceStatic.saveElementJson("form-patient-information", data);
    }

    static getFormPatientInformation(){
        try {
            return this.localConfigServiceStatic.getElementJson("form-patient-information");
        } catch (error) {
            return "";
        }
    }

    static removeFormPatientInformation() {
        try {
            this.localConfigServiceStatic.removeElement("form-patient-information");
        } catch (error) {

        }
    }

    // FORM - ADDRESS
    static saveFormAddressInformation(data: any) {
        this.localConfigServiceStatic.saveElementJson("form-address-information", data);
    }

    static getFormAddressInformation() {
        try {
            return this.localConfigServiceStatic.getElementJson("form-address-information");
        } catch (error) {
            return "";
        }
    }

    static removeFormAddressInformation() {
        try {
            this.localConfigServiceStatic.removeElement("form-address-information");
        } catch (error) { }
    }

    // FORM - AFFILIATION
    static saveFormAffiliationInformation(data: any) {
        this.localConfigServiceStatic.saveElementJson("form-affiliation-information", data);
    }

    static getFormAffiliationInformation() {
        try {
            return this.localConfigServiceStatic.getElementJson("form-affiliation-information");
        } catch (error) {
            return "";
        }
    }

    static removeFormAffiliationInformation() {
        try {
            this.localConfigServiceStatic.removeElement("form-affiliation-information");
        } catch (error) { }
    }

    // FORM - CONTACT
    static saveFormContactInformation(data: any) {
        this.localConfigServiceStatic.saveElementJson("form-contact-information", data);
    }

    static getFormContactInformation() {
        try {
            return this.localConfigServiceStatic.getElementJson("form-contact-information");
        } catch (error) {
            return "";
        }
    }

    static removeFormContactInformation() {
        try {
            this.localConfigServiceStatic.removeElement("form-contact-information");
        } catch (error) { }
    }

    static getUserFullName(){
        try {
            return this.localConfigServiceStatic.getElement("fullname");
        } catch (error) {
            return "";
        }
    }


    static savePatientIdMenu(patientId: number){
        this.localConfigServiceStatic.saveElement("patientId-menu", patientId);
    }

    static getPatientIdMenu(){
        try {
            return this.localConfigServiceStatic.getElement("patientId-menu");
        } catch (error) {
            return "";
        }
    }

    static saveListSurgeryRequest(listId: string[]){
        this.localConfigServiceStatic.saveElementJson("list-surgery-request", listId);
    }

    static getListSurgeryRequest(){
        let listMap = new Map<number, number>();
        let list: string[] = this.localConfigServiceStatic.getElementJson("list-surgery-request");
        if (StringUtilsHelper.notNullOrUndefinedOrEmpty(list)) {                    
            list.forEach(item => {
                let row = item.split('-');
                listMap.set(Number(row[0]), Number(row[1]));
            });
        }
        return listMap;
    }

    static getUserId(){
        try {
            return this.localConfigServiceStatic.getElement(user.iduser);
        } catch (error) {
            return "";
        }
    }

    static savePatientIdVisit(patientId: number){
        this.localConfigServiceStatic.saveElement("patientId-visit", patientId);
    }
    static getPatientIdVisit(){
        try {
            return this.localConfigServiceStatic.getElement("patientId-visit");
        } catch (error) {
            return "";
        }
    }

    static savePatientIdMedicalAppointment(patientIdMedicalSchedule: number){
        this.localConfigServiceStatic.saveElement("patientId-medical-appointment", patientIdMedicalSchedule);
    }
    static getPatientIdMedicalAppointment(){
        try {
            return this.localConfigServiceStatic.getElement("patientId-medical-appointment");
        } catch (error) {
            return "";
        }
    }

    static saveSsIdMedicalAppointment(ssId: number){
        this.localConfigServiceStatic.saveElement("ssId-medical-appointment", ssId);
    }
    static getSsIdMedicalAppointment(){
        try {
            return this.localConfigServiceStatic.getElement("ssId-medical-appointment");
        } catch (error) {
            return "";
        }
    }

    static saveUnitId(unitId: number) {
        this.localConfigServiceStatic.saveElement("unitId", unitId);
    }

    static getUnitId() {
        try {
            return this.localConfigServiceStatic.getElement("unitId");
        } catch (error) {
            return "";
        }
    }

    static saveSpecialityId(specialityId: number) {
        this.localConfigServiceStatic.saveElement("specialityId", specialityId);
    }

    static getSpecialityId() {
        try {
            return this.localConfigServiceStatic.getElement("specialityId");
        } catch (error) {
            return "";
        }
    }

    static savePatientBirthdate(patientBirthdate: string) {
        this.localConfigServiceStatic.saveElement("patient-birthdate", patientBirthdate);
    }



    static getPatientBirthdate() {
        try {
            return this.localConfigServiceStatic.getElement("patient-birthdate");
        } catch (error) {
            return "";
        }
    }

    static savePatientIdBiologicalSex(patientId: number){
        this.localConfigServiceStatic.saveElement("patientId-bilogicalsex", patientId);
    }
    static getPatientBiologicalSex(){
        try {
            return this.localConfigServiceStatic.getElement("patientId-bilogicalsex");
        } catch (error) {
            return "";
        }
    }

    static getBranchIdData(){
        try {
            return this.localConfigServiceStatic.getElement(userSession.idbranch);
        } catch (error) {
            return "";
        }
    }

    saveHolidayDay(holidayDay : ModuleHolidayDaysDto){
        this.localConfigService.saveElement(userSession.holidayDay, JSON.stringify(holidayDay));
    }

    saveLockTypes(listLockTypes : LockTypesDto[]){
        this.localConfigService.saveElement(userSession.listLockTypes, JSON.stringify(listLockTypes));
    }

    saveProcedure(procedure : ProcedureDto){
        this.localConfigService.saveElement(userSession.procedure, JSON.stringify(procedure));
    }

    saveCatalogSexType(sexType : SexTypeDto){
        this.localConfigService.saveElement(userSession.sexType, JSON.stringify(sexType));
    }

    saveCatalogProcedureType(procedureType : ProcedureTypeDto){
        this.localConfigService.saveElement(userSession.procedureType, JSON.stringify(procedureType));
    }

    saveCatalogProcedureUpdate(procedureUpd : ProcedureUpdateDto){
        this.localConfigService.saveElement(userSession.procedureUpdate, JSON.stringify(procedureUpd));

    }

    saveAllVitalSignsByBranchOffId(listVitalSigns : VitalSignResponse[]){
        this.localConfigService.saveElement(userSession.vitalSignsByBranchOffId, JSON.stringify(listVitalSigns));
    }

    saveVitalSign(vitalSign : VitalSignResponse){
        this.localConfigService.saveElement(userSession.vitalSign, JSON.stringify(vitalSign));
    }

    saveCatalogUnits(listUnits : UnitMenu[]){
        this.localConfigService.saveElement(userSession.catalogUnits, JSON.stringify(listUnits));
    }

    saveCatalogUnitiesMeasurement(listUnitiesMeasurement : UnitiesMeasurementDto[]){
        this.localConfigService.saveElement(userSession.catalogUnitiesMeasurement, JSON.stringify(listUnitiesMeasurement));
    }

    saveCatalogVitalSignsType(listVitalSignsType : VitalSignTypeDto[]){
        this.localConfigService.saveElement(userSession.catalogVitalSignsType, JSON.stringify(listVitalSignsType));
    }

    saveCatalogOptionSex(listOptionSex : OptionSexDto[]){
        this.localConfigService.saveElement(userSession.catalogOptionSex, JSON.stringify(listOptionSex));
    }

    saveCatalogClueAge(listClueAge : ClueAgeDto[]){
        this.localConfigService.saveElement(userSession.catalogClueAge, JSON.stringify(listClueAge));
    }

    saveTimeOut(time: string){
        this.localConfigService.saveElement(userSession.inactivityTime, time);
        this.localConfigService.saveElement(user.idle, false);
    }

    saveEndTimeBlockedSession(time: string){
        this.localConfigService.saveElement(userSession.endTimeBlockedSession, time);
    }

    getWorkplaces(){
        return JSON.parse(this.localConfigService.getElement(workplaces));
    }

    getOrgId(){
        return this.localConfigService.getElement(userSession.idorg);
    }

    getBranchId(){
        return this.localConfigService.getElement(userSession.idbranch);
    }

    getProfileId(){
        return this.localConfigService.getElement(userSession.idprofile);
    }

    static getLanguageCve(){
        return this.localConfigServiceStatic.getElement(userSession.languageCve);
    }
    static getLanguageCountryCve(){
        const language = this.localConfigServiceStatic.getElement(userSession.languageCve);
        switch(language){
            case 'es':{
                return 'es-MX';
            }
            case 'en':{
                return 'en-US';
            }
            case 'pt':{
                return 'pt-BR';
            }
            default:{
                return 'es-MX';
            }
        }
    }
    getLockTypes(){
        return JSON.parse(this.localConfigService.getElement(userSession.listLockTypes));
    }

    getHolidayDay(){
        return JSON.parse(this.localConfigService.getElement(userSession.holidayDay));
    }

    getProcedure(){
        return JSON.parse(this.localConfigService.getElement(userSession.procedure));
    }

    getCatalogSexType(){
        return JSON.parse(this.localConfigService.getElement(userSession.sexType));
    }

    getCatalogProcedureType(){
        return JSON.parse(this.localConfigService.getElement(userSession.procedureType));
    }

    getCatalogProcedureUpdate(){
        return JSON.parse(this.localConfigService.getElement(userSession.procedureUpdate));
    }

    getVitalSign(){
        return JSON.parse(this.localConfigService.getElement(userSession.vitalSign));
    }

    getVitalSignsByBranchOffId(){
        return JSON.parse(this.localConfigService.getElement(userSession.vitalSignsByBranchOffId));
    }

    getCatalogUnitiesMeasurement(){
        return JSON.parse(this.localConfigService.getElement(userSession.catalogUnitiesMeasurement));
    }

    getCatalogVitalSignsType(){
        return JSON.parse(this.localConfigService.getElement(userSession.catalogVitalSignsType));
    }

    getCatalogUnits(){
        return JSON.parse(this.localConfigService.getElement(userSession.catalogUnits));
    }

    getCatalogClueAge(){
        return JSON.parse(this.localConfigService.getElement(userSession.catalogClueAge));
    }

    getCatalogOptionSex(){
        return JSON.parse(this.localConfigService.getElement(userSession.catalogOptionSex));
    }

    static getForms(){
        return JSON.parse(this.localConfigServiceStatic.getElement(userSession.formsByLanCveAndOrgId));
    }

    static getFormId(url : string): any{
        let list = this.getForms();
        let objForm = StringUtilsHelper.findByDataForList(list, "url", url);
        if (objForm) {
            return objForm;
        }
        return undefined;
    }

    static getIdByUrl(url: string): number{
        const form: FormOrgLangDto = this.getFormId(url);
        if(form){
            return form.formId;
        }
        return undefined;
    }

    static getExternalId(){
        return JSON.parse(this.localConfigServiceStatic.getElement("external-id"));
    }
    static getHospitalizationId(){
        return JSON.parse(this.localConfigServiceStatic.getElement("hospitalization-id"));
    }
    static getEmergencyId(){
        return JSON.parse(this.localConfigServiceStatic.getElement("emergency-id"));
    }
    static getOperatingRoomId(){
        return JSON.parse(this.localConfigServiceStatic.getElement("operating-room-id"));
    }
    static getObjExternal(){
        return JSON.parse(this.localConfigServiceStatic.getElement("obj-external"));
    }
    static getObjHospitalization(){
        return JSON.parse(this.localConfigServiceStatic.getElement("obj-hospitalization"));
    }
    static getObjEmergency(){
        return JSON.parse(this.localConfigServiceStatic.getElement("obj-emergency"));
    }
    static getObjOperatingRoom(){
        return JSON.parse(this.localConfigServiceStatic.getElement("obj-operating-room"));
    }

    static saveObjExternal(externalData: any) {
        this.localConfigServiceStatic.saveElement("obj-external", JSON.stringify(externalData));
    }

    static saveObjHospitalization(hospitalizationData: any) {
        this.localConfigServiceStatic.saveElement("obj-hospitalization", JSON.stringify(hospitalizationData));
    }

    static saveObjEmergency(emergencyData: any) {
        this.localConfigServiceStatic.saveElement("obj-emergency", JSON.stringify(emergencyData));
    }

    static saveObjOperatingRoom(opData: any) {
        this.localConfigServiceStatic.saveElement("obj-operating-room", JSON.stringify(opData));
    }

    static saveOverAccesGrants(grants: any) {
        this.localConfigServiceStatic.saveOnSessionElementJson("overAccessGrants", grants);
    }

    static getOverAccesGrants(){
        return this.localConfigServiceStatic.getOnSessionElementJson("overAccessGrants");
    }

    // NOTES - STAY DETAILS
    static saveFormStayDetails(data: any) {
        this.localConfigServiceStatic.saveElementJson("form-stay-details", data);
    }

    static getFormStayDetails() {
        try {
            return this.localConfigServiceStatic.getElementJson("form-stay-details");
        } catch (error) {
            return "";
        }
    }

    static removeFormStayDetails() {
        try {
            this.localConfigServiceStatic.removeElement("form-stay-details");
        } catch (error) { }
    }

    // NOTES - COMORBIDITIES
    static saveFormComorbidities(data: any) {
        this.localConfigServiceStatic.saveElementJson("form-comorbidities", data);
    }

    static getFormComorbidities() {
        try {
            return this.localConfigServiceStatic.getElementJson("form-comorbidities");
        } catch (error) {
            return "";
        }
    }

    static removeFormComorbidities() {
        try {
            this.localConfigServiceStatic.removeElement("form-comorbidities");
        } catch (error) { }
    }

    // NOTES - PROCEDURE
    static saveFormDiagnosticProcedure(data: any) {
        this.localConfigServiceStatic.saveElementJson("form-diagnostic-procedure", data);
    }

    static getFormDiagnosticProcedure() {
        try {
            return this.localConfigServiceStatic.getElementJson("form-diagnostic-procedure");
        } catch (error) {
            return "";
        }
    }

    static removeFormDiagnosticProcedure() {
        try {
            this.localConfigServiceStatic.removeElement("form-diagnostic-procedure");
        } catch (error) { }
    }

    // NOTES - VIOLENCE
    static saveFormViolence(data: any) {
        this.localConfigServiceStatic.saveElementJson("form-violence", data);
    }

    static getFormViolence() {
        try {
            return this.localConfigServiceStatic.getElementJson("form-violence");
        } catch (error) {
            return "";
        }
    }

    static removeFormViolence() {
        try {
            this.localConfigServiceStatic.removeElement("form-violence");
        } catch (error) { }
    }

    // NOTES - HISTGYNE
    static saveFormHistGyne(data: any) {
        this.localConfigServiceStatic.saveElementJson("form-hist-gyne", data);
    }

    static getFormHistGyne() {
        try {
            return this.localConfigServiceStatic.getElementJson("form-hist-gyne");
        } catch (error) {
            return "";
        }
    }

    static removeFormHistGyne() {
        try {
            this.localConfigServiceStatic.removeElement("form-hist-gyne");
        } catch (error) { }
    }

    // NOTES - PRODUCT
    static saveFormProduct(data: any) {
        this.localConfigServiceStatic.saveElementJson("form-product", data);
    }

    static getFormProduct() {
        try {
            return this.localConfigServiceStatic.getElementJson("form-product");
        } catch (error) {
            return "";
        }
    }

    static removeFormProduct() {
        try {
            this.localConfigServiceStatic.removeElement("form-product");
        } catch (error) { }
    }

    // NOTES - PSYCHOSPI
    static saveFormPsycHospi(data: any) {
        this.localConfigServiceStatic.saveElementJson("form-psychiatric-hospi", data);
    }

    static getFormPsycHospi() {
        try {
            return this.localConfigServiceStatic.getElementJson("form-psychiatric-hospi");
        } catch (error) {
            return "";
        }
    }

    static removeFormPsycHospi() {
        try {
            this.localConfigServiceStatic.removeElement("form-psychiatric-hospi");
        } catch (error) { }
    }
}
